import { render, staticRenderFns } from "./GastroAnamnesiFamiliareView.vue?vue&type=template&id=efc5598c"
import script from "./GastroAnamnesiFamiliareView.vue?vue&type=script&lang=js"
export * from "./GastroAnamnesiFamiliareView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports